var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWom = function SvgWom(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 15C11.4715 15 14.2857 12.3137 14.2857 9C14.2857 5.68629 11.4715 3 8 3C4.5285 3 1.71429 5.68629 1.71429 9C1.71429 12.3137 4.5285 15 8 15ZM8 16.6364C12.4183 16.6364 16 13.2174 16 9C16 4.78255 12.4183 1.36364 8 1.36364C3.58172 1.36364 0 4.78255 0 9C0 13.2174 3.58172 16.6364 8 16.6364Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2857 0C10.7591 0 11.1429 0.366312 11.1429 0.818182V7.36364C11.1429 7.81551 10.7591 8.18182 10.2857 8.18182C9.81233 8.18182 9.42857 7.81551 9.42857 7.36364V0.818182C9.42857 0.366312 9.81233 0 10.2857 0Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.71429 0C6.18767 0 6.57143 0.366312 6.57143 0.818182V7.36364C6.57143 7.81551 6.18767 8.18182 5.71429 8.18182C5.2409 8.18182 4.85714 7.81551 4.85714 7.36364V0.818182C4.85714 0.366312 5.2409 0 5.71429 0Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.71429 15.2727C6.18767 15.2727 6.57143 15.639 6.57143 16.0909V17.1818C6.57143 17.6337 6.18767 18 5.71429 18C5.2409 18 4.85714 17.6337 4.85714 17.1818V16.0909C4.85714 15.639 5.2409 15.2727 5.71429 15.2727Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2857 15.2727C10.7591 15.2727 11.1429 15.639 11.1429 16.0909V17.1818C11.1429 17.6337 10.7591 18 10.2857 18C9.81233 18 9.42857 17.6337 9.42857 17.1818V16.0909C9.42857 15.639 9.81233 15.2727 10.2857 15.2727Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.03598 10.5429C4.40563 10.2606 4.94502 10.3179 5.24074 10.6707C5.88373 11.4379 6.82705 11.983 7.79632 12.0719C8.71952 12.1567 9.77963 11.8396 10.7593 10.6707C11.055 10.3179 11.5944 10.2606 11.964 10.5429C12.3337 10.8252 12.3936 11.3401 12.0979 11.6929C10.7918 13.2513 9.18524 13.8433 7.63225 13.7008C6.12533 13.5625 4.78294 12.7439 3.90211 11.6929C3.60639 11.3401 3.66632 10.8252 4.03598 10.5429Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWom, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wom.c5c679a7.svg";
export { ForwardRef as ReactComponent };